import { Reducer } from 'redux';
import { ILoanData, ILoanDataAction } from '../actions/loanAction';
import { LoanActionTypes } from '../constants/actionTypes';

// Define the initial state
const initialState: ILoanState = {
  loanData: undefined,
  loanErrors: undefined,
};

export interface ILoanState {
  readonly loanData: ILoanData | undefined;
  readonly loanErrors: string[] | undefined
}

export const loanReducer: Reducer<ILoanState,
ILoanDataAction> = (
  state = initialState,
  action: ILoanDataAction,
) => {
  switch (action.type) {
    case LoanActionTypes.GET_LOAN_DATA:
      return {
        ...state,
        loanData: action.loanData,
        loanErrors: undefined,
      };
    case LoanActionTypes.ERROR_GET_LOAN_DATA:
      return {
        ...state,
        loanData: undefined,
        loanErrors: action.loanErrors,
      };
    default:
      return state;
  }
};
